import { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import NewOverlayLoader from '../../../../components/PurchaseRequisition/common/NewOverlayLoader';
import axios from 'axios';
import FormValidator from '../../../../inc/FormValidator';
import Helper from '../../../../inc/Helper';
import FieldsRenderer from '../../../../components/Purchase Orders Internal/Edit PO/FieldsRenderer';
import $ from 'jquery';
import { formatJson, getPopupMessageBasedOnStatus, isEmptyObject } from '../../../../inc/Validation';
import Popup from '../../../../components/Popup/Popup';
import Collapse from '../../../../components/inc/Collapse';
import Button from '../../../../components/inc/Button';
import Settings from '../../../../inc/Settings';
import Api from '../../../../inc/Api';

let cancelTokenSource = axios.CancelToken.source();
const ActionsPopup = ({ setShowCreateModal, documentLevelState, setDocumentLevelState, reloadParentGrid, user, language }) => {
    const [apiCallBtn, setApiCallBtn] = useState(false);

    let formValidator;

    const validationConfigure = () => {
        let formFieldConfig = [  
            {name:'label', displayName:Helper.getLabel(language,'label','Label'),types:['Required']},
            {name:'url', displayName:Helper.getLabel(language,'url','Url'),types:['Required', 'Url']},
            {name:'method', displayName:Helper.getLabel(language,'method','Method'),types:['Required']},
        ];

        if(!formValidator) {
            formValidator = new FormValidator(formFieldConfig, language)
        }; 
    };

    validationConfigure();

    let payload = { 
        label: documentLevelState?.label,
        url: documentLevelState?.url,
        payload: !isEmptyObject(documentLevelState?.payload) ? formatJson(documentLevelState?.payload) : '',
        method: documentLevelState?.method,
        tenant_id: user?.tenant_id
    };

    const executePOSTAPI = async () => {
        try {
            let api = Api;
            api.setUserToken();
            const res = await api.axios().post(Settings.baseUrl + 'action/', payload,
            { cancelToken: cancelTokenSource.token });

            if (res.data.status === 201) {
                Helper.alert(res?.data?.message); 
                reloadParentGrid();
                onPopupClose(); 
            }
        } catch (error) { 
            getPopupMessageBasedOnStatus(error); 
        }
    };
 
    const executePUTAPI = async () => {
        try {
            let api = Api;
            api.setUserToken()
            const res = await api.axios().put(Settings.baseUrl+`action/${documentLevelState?.action_id}/`, payload,
            { cancelToken: cancelTokenSource.token });

            if (res.data.status === 200) {
                Helper.alert(res?.data?.message); 
                reloadParentGrid();
            }
        } catch (error) { 
            getPopupMessageBasedOnStatus(error); 
        }
    };

    const onPopupClose = () => {
        $("html").removeClass("rs_popup_open");
        setShowCreateModal(false);
    };

    let textBoxInputSettings = [
        {
            className: "col-lg-6",
            label: "Label",
            inputType: "text",
            id: "label",
            required: true,
            name: "label"
        },
        {
            className: "col-lg-6",
            label: "Url",
            inputType: "text",
            id: "url",
            required: true,
            name: "url"
        },
        {
            className: "col-lg-6",
            label: "Method",
            inputType: "dropdown",
            options: Settings.apiHttpMethods,
            id: "method",
            name: "method",
            required: true
        },
        {
            className: "col-lg-6",
            label: "Payload",
            inputType: "textarea",
            id: "payload",
            name: "payload"
        }
    ];

    const handleSubmit = () => { 
        if(!formValidator.isValid({...documentLevelState})){
            formValidator.displayMessage();
            formValidator.reset();
            return;
        };

        if(!documentLevelState?.action_id){
            Helper.createDebouncedAPIFunction( 
                [executePOSTAPI], 
                setApiCallBtn,
                cancelTokenSource
            )();
        } else {
            Helper.createDebouncedAPIFunction( 
                [executePUTAPI], 
                setApiCallBtn,
                cancelTokenSource
            )();
        }
    };

    return (
        <Fragment> 
            { apiCallBtn ? <NewOverlayLoader /> : null }
            <Popup
                autoOpen={true} width="752px"
                onClose={onPopupClose} 
            >
                <>
                    <h5 className="create_rfq_modal__title">{!documentLevelState?.action_id?'Create Action':'Edit Action'}</h5>

                    <Collapse
                        className="mt-4 mb-4" open={true}
                        title={Helper.getLabel(
                            language,
                            "general_info",
                            "General Information"
                        )}
                    >
                        <div className='container-fluid'>
                            <div className='row mb-3'>
                                <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setDocumentLevelState} currentState={documentLevelState} />
                            </div>
                        </div>
                    </Collapse>
                </>

                <div className="addDocumentNumber-body-buttons" style={{ justifyContent: "flex-end" }}>
                    <Button
                        isActive={false} 
                        isDisable={apiCallBtn}
                        className='black-btn-style'
                        title={Helper.getLabel(language, "close", "Close")}
                        onClick={onPopupClose}
                    />

                    <Button
                        isDisable={apiCallBtn}                        
                        className={documentLevelState?.action_id?"solid_btn_blue":"" } 
                        isActive={!documentLevelState?.action_id}
                        title={!documentLevelState?.action_id?Helper.getLabel(language, "create", "Create"):Helper.getLabel(language, "save", "Save")}
                        onClick={handleSubmit}
                    />
                </div>
            </Popup>
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        appOptions: state.options,
        auth: state.auth,
        user: state.auth.user,
        language: state.language,
    };
};

export default connect(mapStateToProps) (ActionsPopup);